import React, { FC } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useFormContext } from "react-hook-form";

import { Button } from "ui-library/atoms";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "ui-library/modules";

import i18n from "core/i18n";
import modal from "core/modal";
import { Field } from "core/hookForm";
import { FileItem } from "types/form";

import { MODAL_UPLOAD_ATTACHMENT } from "../constants";
import { VehicleSubjectChangeFormValues } from "../types/VehicleSubjectChangeFormValues";
import useUploadRemoveAttachment from "../hooks/useUploadRemoveAttachment";

export interface AttachmentUploadModalProps {
    attachmentType: string;
}

export const AttachmentUploadModal: FC<AttachmentUploadModalProps> = ({ attachmentType }) => {
    const { t } = i18n.useTranslation();
    const dispatch = useDispatch();

    const { idObject } = useParams();
    const { getValues, watch } = useFormContext<VehicleSubjectChangeFormValues>();
    const changeSheetId = getValues("idChange");

    const { uploadAttachment } = useUploadRemoveAttachment(idObject, changeSheetId);

    const onUploadAttachment = async (file: FileItem) => {
        return await uploadAttachment(attachmentType, file);
    };

    const isModalFormOpen = useSelector(modal.isModalFormOpen(MODAL_UPLOAD_ATTACHMENT));

    const closeModalForm = () => {
        dispatch(modal.closeModalForm(MODAL_UPLOAD_ATTACHMENT));
    };

    return (
        <Modal size="small" open={isModalFormOpen} onClose={closeModalForm}>
            <ModalHeader
                icon="document-upload"
                title={t("vehicle.change.subject.documents.attachmentUpload")}
                closeAction={closeModalForm}
            />
            <ModalBody>
                <Field<VehicleSubjectChangeFormValues>
                    name={`attachments.${attachmentType}`}
                    input="fileDropArea"
                    maxUploadedFiles={20}
                    onLoadFile={onUploadAttachment}
                />
            </ModalBody>
            <ModalFooter>
                <Button variant="contained" color="primary" onClick={closeModalForm}>
                    {t("common.close")}
                </Button>
            </ModalFooter>
        </Modal>
    );
};
